const faqModule = {
    initEvents () {
        $(document).on('click', '.article__faq-subtitle', function () {
            $(this).closest('.article__faq-block').toggleClass('faq-item-open')
        })
    },

    init(){
        this.initEvents();
    }
}

export default faqModule;
